module.exports = __webpack_public_path__ + "img/oaFlowData193@3x.cffa8d2b.png";